export default __webpack_public_path__ + "static/media/undraw_unlock_-24-mb.8a02a66d.svg";